import en from "i18n-iso-countries/langs/en.json";
import no from "i18n-iso-countries/langs/no.json";
import sv from "i18n-iso-countries/langs/sv.json";
import { memoize, sortBy } from "lodash";
import { Language } from "../i18n/languages";

const countries = {
  [Language.NO.toString()]: new Map(Object.entries(no.countries)),
  [Language.SV.toString()]: new Map(Object.entries(sv.countries)),
  [Language.EN.toString()]: new Map(
    Object.entries(en.countries).map(([isoCode, names]) => [
      isoCode,
      fixEnglishName(isoCode, names),
    ]),
  ),
};

/**
 * There are entries with multiple names in the English translation file.
 * Pick the "neutral" / "natural" candidate, which fits the Norwegian worldview atm.
 */
function fixEnglishName(isoCode: string, names: string | string[]) {
  if (typeof names === "string") {
    return names;
  }
  switch (isoCode) {
    case "IR":
      return "Iran";
    case "PS":
      return "Palestine";
    case "RU":
      return "Russia";
    case "TW":
      return "Taiwan";
    case "GB":
      return "United Kingdom";
    case "US":
      return "United States";
    default:
      return names[0];
  }
}

export function getCountryName(isoCode: string, locale: string): string | undefined {
  if (!(locale in countries)) {
    throw new Error("Country names hasn't been defined for the given locale:" + locale);
  }
  return countries[locale].get(isoCode);
}

export const getAllCountriesSortedByName: (locale: Language) => { code: string; name: string }[] =
  memoize((locale: Language) =>
    sortBy(
      Array.from(countries[locale].entries()).map(([code, name]) => ({ code, name })),
      "name",
    ),
  );

export function isCountryCodeNorway(countryIsoCode?: string) {
  return norway === countryIsoCode?.toUpperCase();
}

export function isCountryCodeSweden(countryIsoCode?: string) {
  return sweden === countryIsoCode?.toUpperCase();
}

export const norway = "NO";
export const sweden = "SE";

export function getDefaultCountryForLocale(locale: Language) {
  if (locale === Language.NO) {
    return norway;
  }
  return undefined;
}
